<template>
  <v-layout row>
    <v-flex xs12 sm12>
      <v-card class="elevation-1 transparent">
        <v-toolbar class="transparent" flat height="37">
          <v-btn icon dark title="Back to company menu" @click="$router.push('/company')">
            <v-icon>arrow_back</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <help-link appId="company" pageId="teams" color="white"></help-link>
          <v-btn v-if="hasEditRights" fab dark small color="primary" title="Add New Team" @click="showAddTeam">
            <v-icon dark>add</v-icon>
          </v-btn>
        </v-toolbar>
        <v-progress-linear v-if="loading" indeterminate color="primary" height="3" class="mt-0"></v-progress-linear>
      </v-card>

      <v-alert v-if="error" :value="true" color="error" icon="error" outline>
          Error encountered. Please contact support. Error details: {{errorMessage}}
      </v-alert>  

      <v-expansion-panel v-model="panel" expand class="mt-5">
        <v-expansion-panel-content v-for="(item,index) in filtered_teams" :key="index">
          <template v-slot:header>
              <span class="font-weight-bold primary--text">
                  <span class="font-weight-bold primary--text">{{ item.name }}</span>
              </span>
              <v-spacer></v-spacer>
          </template>
          <v-card class="elevation-1 transparent">
            <v-toolbar flat class="transparent" height="35px">
                <span :class="isMobile?'ml-7':''">{{ item.description }}</span>
                <v-spacer></v-spacer>
                <v-btn icon title="Edit Team Details" v-if="hasEditRights" @click="editTeam(item)">
                    <v-icon small>edit</v-icon>
                </v-btn>
                <v-btn icon title="Delete Team" v-if="hasDeleteRights && !getTeamMembersByTeam(item.teamId).length" @click="showDelete(item)">
                    <v-icon small>delete</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-chip-group column>
                <v-chip
                  v-for="(item2, index2) in getTeamMembersByTeam(item.teamId)"
                  :key="index2"
                  @click="viewUserProfile(item2)"
                >
                  <v-avatar left>
                    <v-img :src="awsS3Helper.getAvatarUrl(item2.userId)"></v-img>
                  </v-avatar>
                  {{item2.firstName}} {{item2.lastName}}
                </v-chip>
              </v-chip-group>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>

    <v-dialog v-model="dialogAdd" persistent width="500" > 
      <add-edit-team ref="addEditTeamRef" :dialogAdd.sync="dialogAdd" @send="getTeams(false)"></add-edit-team>
    </v-dialog>
    <v-dialog v-model="dialogDelete" width="500">
      <delete ref="refDeleteComponent" :dialogDelete.sync="dialogDelete" @okDelete="deleteTeam"></delete>
    </v-dialog>
    
  </v-layout>  
</template>
<script>

import teamApi from '@/api/team'
import awsS3Helper from '@/helpers/aws-s3'
import { hasEditRights, hasDeleteRights } from '@/helpers/access-permissions'

export default {    
    name: 'Teams',
    metaInfo: {
      title: 'Teams',
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: 'View list of company teams, all members for each teams and their roles' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1' }
      ]
    }, 
    components: {
      'delete': () => import('@/components/BasicPopups/Delete'),
      'help-link': () => import('@/components/Common/HelpLink'),
      'add-edit-team' : () => import('@/components/Team/AddEditTeam')
    },   
    data () {
      return {
        awsS3Helper,
        teams: [],
        filtered_teams: [],
        team_members: [],
        panel: [false],
        error: false,
        errorMessage: '',
        loading: false,
        dialogAdd: false,
        dialogDelete: false,
        selectedTeamId: null
      }
    },
    methods: {      
      async deleteTeam() {
        try {          
          const response = await teamApi.delete(this.selectedTeamId)
          if (response && response.status == 200) {
            await this.getTeams(false)
            this.dialogDelete = false
          }
        }catch(error){
          this.error = true
          this.errorMessage = error
        }
      },
      showDelete(data) {
        this.selectedTeamId = data.teamId
        this.$refs.refDeleteComponent.setMessage(`Delete <b>${data.name}</b> team?`)
        this.dialogDelete = true
      },
      editTeam(data) {
        this.$refs.addEditTeamRef.setEditParams(data)
        this.dialogAdd=true
      },
      viewUserProfile(data) {
        if (this.loggedInuserId == data.userId) this.$router.push('/myprofile')
        else this.$router.push(`/hr/employees/${data.userId}`)
      },
      showAddTeam() {
        this.$refs.addEditTeamRef.setAddParams()
        this.dialogAdd=true
      },
      async getTeams(show_loading) {
        try {
          this.loading = show_loading
          const response = await teamApi.getTeamsByCompany(true)
          if (response && response.status == 200) {
            this.teams = response.data.items
            this.filtered_teams = response.data.items
            this.team_members = response.data.membersItems
          }
          this.loading = false
        }catch(error){
          this.error = true
          this.errorMessage = error
        }
      },
      getTeamMembersByTeam(teamId) {         
        return this.team_members.filter(item => {
          return item.teamId == teamId
        })
      }
    },
    created() {
      //update header titles
      this.$root.$emit('setHeaderTitles', {
          display: true,
          headerTitle: '',
          headerPageTitle: 'Company Teams'
      })
      this.getTeams(true)
    },
    computed: {
      hasEditRights() {
          return hasEditRights(this.$router.currentRoute.path)
      },
      hasDeleteRights() {
        return hasDeleteRights(this.$router.currentRoute.path)
      },
      loggedInuserId() {
        return this.$store.state.userId
      },
    }
  }
</script>